import CPlusplusInactive from './c-plusplus-inactive';

export default CPlusplusInactive;
